<template>
  <sa-page-layout :btnSaveVisible="false" :btnRouterBackVisible="true" :data="jsonData"
    :showModalLoading="showModalLoading" :pathResource="pathResource">
    <template slot="toolbar">
      <b-button variant="danger btn-toolbar float-sm-right sa-margin-right" size="sm" v-if="isEdit && id != '-1'"
        @click="onAnnullaModifica"><b-icon icon="x"></b-icon>Annulla</b-button>
      <b-button variant="success btn-toolbar float-sm-right sa-margin-right" size="sm" v-if="isEdit && id == '-1'"
        @click="onClickSalva('onClickSave')"><b-icon icon="check2"></b-icon>Salva</b-button>
      <b-button variant="purple btn-toolbar float-sm-right sa-margin-right" size="sm" v-if="id == '-1'"
        @click="onClickApriModale"><i class="bi bi-building"></i>Struttura e Tipologia Ricetta</b-button>

      <b-button variant="success btn-toolbar float-sm-right sa-margin-right" size="sm"
        v-if="isEdit && id != '-1' && step == 1" @click="onClickSalva('onClickSalvaModifica')"><b-icon
          icon="check2"></b-icon>Modifica Anagrafica</b-button>

      <b-button variant="primary btn-toolbar float-sm-right sa-margin-right" size="sm" v-if="!isEdit"
        @click="onClickModifica"><b-icon icon="pencil"></b-icon>Modifica</b-button>


      <!-- <b-button variant="success btn-toolbar float-sm-right sa-margin-right" size="sm"
        v-if="isEdit && id != '-1' && step == 2" @click="onClickSalva('onClickSalvaModificaRicetta')"><b-icon
          icon="check2"></b-icon>Modifica Prestazioni Impegnativa</b-button> -->
    </template>

    <template slot="table-body">


      <b-modal ref="mdlChooseTipologiaRicetta"
        :title="externaStepper == 1 ? 'Struttura Riferimento' : 'Tipologia Ricetta'" size="medium"
        style="height: 100%; max-height: 100%; width: 100%; max-width: 100%" centered scrollable footer-tag="footer"
        no-close-on-backdrop no-close-on-esc hide-header-close>
        <step-component :initStepper="externaStepper" :hideTitleDiv="true" :btnAvantiDefault="false"
          :btnSaveDeafult="false" :steps="steps" @stepperUpdated="onStepperStrutturaRicettaUpdated">
          <template v-slot:step-1>
            <b-card-text style="display: flex; justify-content: center; width: 100%">
              <accettazione-ssn-struttura-presidio-component ref="cmpPresidioComponent"
                :jsonData="jsonData.accettazione" :isEdit="!isEdit"
                @changeJsonData="onChangeStrutturaJSON"></accettazione-ssn-struttura-presidio-component>
            </b-card-text>
          </template>
          <template v-slot:step-2 style="display: flex; justify-content: center; width: 100%"><span>Ricetta
              Dematerializzata ?</span> </template>
        </step-component>
        <template #modal-footer>
          <div v-if="externaStepper == 2" style="display: flex; justify-content: center; width: 100%">
            <b-button size="sm" v-b-tooltip.hover title="No" variant="danger btn-toolbar sa-margin-right"
              @click="onNoRicettaDematerializzata()">
              <font-awesome-icon icon="check" />
              No
            </b-button>
            <b-button size="sm" v-b-tooltip.hover title="Si" variant="success btn-toolbar sa-margin-right"
              @click="onSiRicettaDematerializzata()">
              <font-awesome-icon icon="check" />
              Si
            </b-button>
          </div>
          <div v-else style="display: flex; justify-content: center; width: 100%">
            <b-button size="sm" v-b-tooltip.hover title="Conferma Struttura/Presidio/Regime"
              variant="danger btn-toolbar sa-margin-right" @click="onAnnullaConfermaStruttura()">
              <font-awesome-icon icon="times" />
              Annulla
            </b-button>
            <b-button size="sm" v-b-tooltip.hover title="Conferma Struttura/Presidio/Regime"
              variant="success btn-toolbar sa-margin-right" @click="onClickConfermaStrutturaRiferimento()"
              :disabled="isStrutturaSelected">
              <font-awesome-icon icon="check" />
              Conferma
            </b-button>
          </div>
        </template>
      </b-modal>

      <accettazione-ssn-edit-view-component ref="cmpAccettazioneEditViewComponent" :isEdit="isEdit" :jsonData="jsonData"
        :tipologiaRicetta="tipologiaRicetta" :isDematerializzata="isDematerializzata"
        :isFirstDematerializzata="isFirstDematerializzata" @stepperUpdated="onStepperUpdated"
        @updateJsonRicette="onUpdateJsonRicette" @onAggiungiImpegnativa="onAggiungiImpegnativa"
        @isTipologiaDematerilizzata="onIsTipologiaDematerilizzata" @beforeLoadData="onBeforeLoadData"
        @afterLoadData="onAfterLoadData" @changeJsonDataImpegnative="changeJsonDataImpegnative"
        @changeStruttura="onChangeJsonStruttura" @changeJsonDataAnagrafica="onChangeJsonDataAnagrafica"
        @changeJsonAccettazioneSsn="onChangeJsonAccettazioneSsn" @onOpenModalStruttura="onOpenModalStrutturaChoise"
        @reload="onReload" :key="keyComponentView" />

      <accettazione-ssn-impegnativa-modal-component1 ref="cmpAccettazioneImpegnativa"
        :isDematerializzata="isDematerializzata" :noCloseOnEsc="true" :hideHeaderClose="true" :btnAnnullaShow="true"
        @onAggiungiImpegnativa="onAggiungiImpegnativa" @onAnnulla="onAnnullaAccettazioneSSN" :isEdit="true" />
    </template>
  </sa-page-layout>
</template>

<script>
// import DatePicker from "vue2-datepicker";
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import AccettazioneSsnEditViewComponent from "../components/AccettazioneSsnEditViewComponent.vue";
import UtilityMixin from "../../../utility/UtilityMixin.js";
import AccettazioneSsnImpegnativaModalComponent1 from "../components/AccettazioneSsnImpegnativaModalComponent.vue";
import StepComponent from "../../ssn/utility/StepComponent.vue";
import AccettazioneSsnStrutturaPresidioComponent from "../components/AccettazioneSsnStrutturaPresidioComponent.vue";
import axios from "axios";
import toast from "../../../../template/layout/utility/sa-toast";
export default {
  inject: ["openShowModalLoading", "closeShowModalLoading"],
  mixins: [UtilityMixin],
  components: {
    SaPageLayout,
    AccettazioneSsnEditViewComponent,
    StepComponent,
    AccettazioneSsnImpegnativaModalComponent1,
    AccettazioneSsnStrutturaPresidioComponent,
  },
  computed: {
    isStrutturaSelected() {
      if (!this.jsonData.accettazione.codiceStruttura) {
        return true;
      } else if (!this.jsonData.accettazione.idPresidio) {
        return true;
      } else {
        return false;
      }
    },
  },
  data() {
    return {
      steps: ["Struttura", "Dematerializzata"],
      isDematerializzata: false,
      showModalLoading: false,
      pathResource: "/accettazionessn",
      linkback: "accettazionessn",
      linkNotBack: null,
      keyComponentView: 0,
      newLink: null,
      componentKey: 0,
      isFirstDematerializzata: false,
      isEdit: false,
      impegnativeKey: 0,
      id: null,
      tipologiaRicetta: null,
      pathResourceImpegnative: "/accettazionericette",
      jsonData: {
        cittadinanza: null,
        statoCivile: null,
        anonimato: true,
        stp: false,
        eni: true,
        conv: false,
        team: true,
        emailBox: true,
        sconosciuto: false,
        noteCaratteristichePaziente: null,
        rilasciatoDa: null,
        documento: null,
        partitaIva: null,
        identificazioneIstituzione: null,
        tipologiaDocumento: null,
        identificazioneTessera: null,
        scadenzaStpEni: null,
        scadenzaTessera: null,
        note: "",
        accettazione: {

          codiceStruttura: null,
          idPresidio: null,
          regime: 'AMBULATORIALE',
          descrizioneLivello: null,
          idSetting: null,
          settingCodice: null,
          settingDescrizione: null,
          idSettingLivello: null,
          accettazioniAsl: {
            aslDomicilioDistretto: "",
            aslResidenzaDistretto: "",
            aslResidenzaCodice: null,
            aslDomicilioCodice: null,
            aslDomicilioAmbito: "",
            aslResidenzaAmbito: "",
          },
          accettazioneAnagrafica: {
            identificativo: null,
            tipoIdentificativo: "CF",
            cognome: null,
            nome: null,
            sesso: null,
            dataNascita: null,
            comuneNascitaCodiceIstat: null,
            regioneResidenza: null,
            regioneDomicilio: null,
            comuneResidenzaCodiceIstat: null,
            comuneDomicilioCodiceIstat: null,
            indirizzoResidenza: null,
            indirizzoDomicilio: null,
            capResidenza: null,
            provinciaDomicilio: null,
            provinciaResidenza: null,
            provinciaNascita: null,
            capDomicilio: null,
            telefono: null,
            email: null,
            gruppoSanguigno: null,
            codiceFiscaleMedicoCurante: "",
            medicoCurante: "",
            emailMedicoCurante: "",
            medicoCuranteTelefono: "",
            linguaMadre: "",
            altreLingueParlate: "",
            note: "",
          },

        },
        ricette: [],
      },
      externaStepper: 1,
      step: 1,
    };
  },
  created() {
    let me = this;
    me.id = this.$route.params.id;
  },
  mounted() {
    let me = this;
    me.id = this.$route.params.id;
    me.isEdit = this.$route.params.id == "-1" ? true : false;

    if (!me.isEdit) {
      me.loadData(me.id);
    } else {
      me.$refs.mdlChooseTipologiaRicetta.show();

    }
  },

  methods: {
    onReload() {
      let me = this;
      me.loadData(me.id);
      me.isEdit = !me.isEdit;
    },
    onBeforeLoadData() {
      let me = this;
      me.showModalLoading = true;
    },
    onClickModifica() {
      let me = this;
      me.isEdit = !me.isEdit;
    },
    onAnnullaModifica() {
      let me = this;
      me.isEdit = false;
    },

    onClickSalva(metodo) {
      let me = this;
      me.jsonData.ricette.forEach((element) => {
        (element._showDetails = false), delete element._showDetails;
        element.codiceFiscaleAssistito = me.jsonData.accettazione.accettazioneAnagrafica.identificativo;
      });
      me.jsonData.identificazioneTessera = me.jsonData.documento;
      switch (metodo) {
        case "onClickSalvaModifica":
          me.onClickSalvaModifica();
          break;
        case "onClickSave":
          me.onClickSave();
          break;
        default:
          break;
      }
    },
    onClickApriModale() {
      this.externaStepper = 1;
      this.$refs.mdlChooseTipologiaRicetta.show();
    },
    onStepperUpdated(stepper) {
      this.step = stepper;
    },
    onSalvaRicetta(response) {
      console.log(response);
    },

    onSalvaRicettaError(response) {
      console.log(response);
    },
    onModificaRicetta(response) {
      console.log(response);
    },
    onAnnullaAccettazioneSSN() {
      this.externaStepper = 1;
      this.$refs.mdlChooseTipologiaRicetta.hide();
    },
    onModificaRicettaError(response) {
      console.log(response);
    },
    onClickSalvaModifica() {
      let me = this;
      delete this.jsonData.integrationAccettazione;
      axios
        .put(process.env.VUE_APP_PATH_API + me.pathResource + "/" + me.jsonData.id, me.jsonData)
        .then((response) => {
          toast.success("Modifica Anagrafica avvenuta con succesaso")
          this.$router.push("/accettazionessn/" + response.data.data.id);
          this.isEdit = false;
        })
        .catch((error) => {
          toast.error(error.response.data.messaggio);
        });
    },
    onClickSave() {
      let me = this;
      me.jsonData.accettazione.regime = "Ambulatoriale";
      axios
        .post(process.env.VUE_APP_PATH_API + me.pathResource, me.jsonData)
        .then((response) => {
          response;
          toast.success("Salvataggio avvenuto con successo")

          this.$router.push("/accettazionessn");
        })
        .catch((error) => {
          toast.error(error.response.data.messaggio);
        });
    },
    onAfterLoadData() {
      let me = this;
      me.showModalLoading = false;
    },
    onUpdateJsonRicette(json) {
      json;
    },
    onOpenModalStrutturaChoise() {
      let me = this;
      me.$refs.mdlChooseTipologiaRicetta.show();
      me.externaStepper = 1;
    },
    onAggiungiImpegnativa(json, jsonIntegrazione) {
      let me = this;
      me.jsonData.ricette.push(JSON.parse(JSON.stringify(json)));
      if (jsonIntegrazione) {
        this.onChangeJsonDataAnagrafica(jsonIntegrazione)
      }
      me.$refs.cmpAccettazioneImpegnativa.hide();
    },
    onChangeJsonStruttura(json) {
      let me = this;
      me.jsonData.codiceStruttura = json.codiceStruttura;
      me.jsonData.idPresidio = json.idPresidio;
    },
    onOpenModalImpegnativa() {
      let me = this;
      me.$refs.cmpAccettazioneImpegnativa.show();
    },
    onSiRicettaDematerializzata() {
      let me = this;
      me.$refs.mdlChooseTipologiaRicetta.hide();
      me.isDematerializzata = true;
      me.onShowModalDematerializzata();
    },
    onShowModalDematerializzata() {
      this.$refs.cmpAccettazioneImpegnativa.showDematerializzata(this.jsonData);
    },

    onNoRicettaDematerializzata() {
      let me = this;
      me.$refs.mdlChooseTipologiaRicetta.hide();
    },
    onChangeJsonDataAnagrafica(json) {
      let me = this;
      let accettazioneAnagrafica = json.accettazioneAnagrafica;
      let accettazioneAsl = json.accettazioniAsl;

      // 1. Creiamo i nuovi oggetti locali con i tuoi dati mappati
      const nuovaAnagrafica = {
        id: accettazioneAnagrafica.id,
        primaryKey: accettazioneAnagrafica.primaryKey,
        idAccettazione: accettazioneAnagrafica.idAccettazione,
        tipo: accettazioneAnagrafica.tipo,
        createDate: accettazioneAnagrafica.createDate,
        createUser: accettazioneAnagrafica.createUser,
        proprietario: accettazioneAnagrafica.proprietario,
        identificativo: accettazioneAnagrafica.identificativo,
        tipoIdentificativo: "CF",
        cognome: accettazioneAnagrafica.cognome,
        nome: accettazioneAnagrafica.nome,
        dataNascita: accettazioneAnagrafica.dataNascita,
        sesso: accettazioneAnagrafica.sesso,
        provinciaNascita: accettazioneAnagrafica.provinciaNascita,
        comuneNascitaCodiceIstat: accettazioneAnagrafica.comuneNascitaCodiceIstat,
        regioneNascita: accettazioneAnagrafica.regioneNascita,
        telefono: accettazioneAnagrafica.telefono,
        email: accettazioneAnagrafica.email,
        regioneResidenza: accettazioneAnagrafica.regioneResidenza,
        provinciaResidenza: accettazioneAnagrafica.provinciaResidenza,
        comuneResidenzaCodiceIstat: accettazioneAnagrafica.comuneResidenzaCodiceIstat,
        indirizzoResidenza: accettazioneAnagrafica.indirizzoResidenza,
        capResidenza: accettazioneAnagrafica.capResidenza,
        regioneDomicilio: accettazioneAnagrafica.regioneDomicilio,
        provinciaDomicilio: accettazioneAnagrafica.provinciaDomicilio,
        comuneDomicilioCodiceIstat: accettazioneAnagrafica.comuneDomicilioCodiceIstat,
        indirizzoDomicilio: accettazioneAnagrafica.indirizzoDomicilio,
        capDomicilio: accettazioneAnagrafica.capDomicilio,
        emailMedicoCurante: "",
        medicoCuranteTelefono: "",
        gruppoSanguigno: accettazioneAnagrafica.gruppoSanguigno,
        medicoCurante: "",
      };

      const nuoveAsl = {
        aslDomicilioCodice: accettazioneAsl.aslDomicilioCodice == null ? "" : accettazioneAsl.aslDomicilioCodice,
        aslDomicilioDenominazione: accettazioneAsl.aslDomicilioDenominazione == null ? "" : accettazioneAsl.aslDomicilioDenominazione,
        aslDomicilioDistretto: accettazioneAsl.aslDomicilioDistretto == null ? "" : accettazioneAsl.aslDomicilioDistretto,
        aslDomicilioAmbito: accettazioneAsl.aslDomicilioAmbito == null ? "" : accettazioneAsl.aslDomicilioAmbito,
        aslResidenzaAmbito: accettazioneAsl.aslResidenzaAmbito == null ? "" : accettazioneAsl.aslResidenzaAmbito,
        aslResidenzaCodice: accettazioneAsl.aslResidenzaCodice == null ? "" : accettazioneAsl.aslResidenzaCodice,
        aslResidenzaDenominazione: accettazioneAsl.aslResidenzaDenominazione == null ? "" : accettazioneAsl.aslResidenzaDenominazione,
        aslResidenzaDistretto: accettazioneAsl.aslResidenzaDistretto == null ? "" : accettazioneAsl.aslResidenzaDistretto,
      };
      me.jsonData = {
        ...me.jsonData,
        accettazione: {
          ...me.jsonData.accettazione,
          accettazioneAnagrafica: nuovaAnagrafica,
          accettazioniAsl: nuoveAsl
        }
      };
    },
    onChangeJsonAccettazioneSsn(json) {
      let me = this;
      console.log("json localdata", json);

      me.jsonData.idAccettazione = json.idAccettazione;
      me.jsonData.statoCivile = json.statoCivile;
      me.jsonData.cittadinanza = json.cittadinanza;
      me.jsonData.noteCaratteristichePaziente = json.noteCaratteristichePaziente;
      me.jsonData.rilasciatoDa = json.rilasciatoDa;
      me.jsonData.documento = json.documento;
      me.jsonData.partitaIva = json.partitaIva;
      me.jsonData.identificazioneIstituzione = json.identificazioneIstituzione;
      me.jsonData.tipologiaDocumento = json.tipologiaDocumento;
      me.jsonData.scadenzaTessera = json.scadenzaTessera;
      me.jsonData.note = json.note;
      me.jsonData.accettazione.idSetting = json.idSetting;
      me.jsonData.accettazione.settingCodice = json.settingCodice;
      me.jsonData.accettazione.regime = json.regime;
      me.jsonData.accettazione.settingDescrizione = json.settingDescrizione;
      me.jsonData.accettazione.idSettingLivello = json.idSettingLivello;
      me.jsonData.accettazione.descrizioneLivello = json.descrizioneLivello;

    },
    onChangeStrutturaJSON(json) {
      let me = this;
      me.jsonData.accettazione.codiceStruttura = json.codiceStruttura;
      me.jsonData.accettazione.idPresidio = json.idPresidio;
      me.jsonData.accettazione.regime = json.regime;
      me.jsonData.accettazione.settingCodice = json.settingDescrizione;
    },
    changeJsonDataImpegnative(ricette) {
      let me = this;
      if (ricette.length >= 1) {
        ricette.forEach((element) => {
          element.codiceFiscaleAssistito = this.jsonData.accettazione.accettazioneAnagrafica.identificativo;
        });
      }

      me.jsonData.ricette = ricette;
    },
    onAnnullaConfermaStruttura() {
      this.$refs.mdlChooseTipologiaRicetta.hide();
      this.$router.push("/accettazionessn");
    },
    onIsTipologiaDematerilizzata(value) {
      let me = this;
      me.isDematerializzata = value;
    },

    onChangeTipologiaRicetta(tipologia) {
      tipologia;
    },
    onClickConfermaStrutturaRiferimento() {
      let me = this;
      me.externaStepper = 2;
    },
    onStepperStrutturaRicettaUpdated(value) {
      let me = this;
      me.externaStepper = value;
    },
    onAnnulla() {
      let me = this;
      me.isDematerializzata = false;
    },
    loadData() {
      let me = this;
      this.openShowModalLoading();

      UtilityMixin.methods.loadDataResources(me.pathResource + "/" + me.id, {}, me.loadDataSuccess, me.loadDataError);
    },
    loadDataSuccess(response) {
      let me = this;
      let reutnrVlaue = response.data.data;
      delete reutnrVlaue.accettazioneAnagrafica;
      delete reutnrVlaue.accettazionePrestazioni;
      delete reutnrVlaue.accettazioneStati;
      delete reutnrVlaue.accettazioneStruttura;
      delete reutnrVlaue.accettazionePresidio;
      delete reutnrVlaue.accettazioniAsl;
      me.jsonData = { ...reutnrVlaue };
      this.closeShowModalLoading();
    },
    loadDataError(error) {
      error;
      this.closeShowModalLoading();
    },
  },
};
</script>
